import React from 'react';
import { connect } from 'react-redux'
import { View, StyleSheet, Text, Platform, ScrollView, TouchableOpacity, Image, ImageBackground } from 'react-native'
import { Button, Icon } from 'react-native-elements'
import { setGameMode, getSexyTables, setGameRoom  } from '../redux/actions'
import { dict as gamemodes } from '../libs/gamemodes'
import ScoreTable from './score-table'
import moment from 'moment'

import ScrollViewWeb from './web/ScrollView';

const noPackage = (pname, pexpire) => {
  switch(pname.toUpperCase()) {
      case '': case null: case 'NONE':
      return true;
  }

  if (!pexpire) {
    throw new Error('No package expire date')
  }

  return moment(pexpire).isBefore(moment())
}

class Gamemode extends React.Component {
    componentDidUpdate() {
        const { subscription, subscription_expire, setGameMode, game_mode, loading } = this.props;
        const vip = !noPackage(subscription, subscription_expire)
        if (!vip) {
            const selectedGameMode = gamemodes.filter(p => p.module === game_mode).pop()
    
            if (!selectedGameMode.free) {
                setGameMode(gamemodes.filter(p => p.free && p.default).pop().module)
            }
        }
    }

    componentDidMount() {
        this.props.getSexyTables()
    }

    SelectRoom = (room) => {
        if (room) {
            this.props.setGameMode('sa')
        } else {
            this.props.setGameMode('manual')
        }

        if (room !== this.props.game_room) {
            this.props.setGameRoom(room)
        }
        this.props.close()
        //console.log(room)
    }

    componentDidUpdate() {
        const { setGameRoom, setGameMode, close, game_mode, loading, saTables, game_room } = this.props;
        const selectedGameMode = gamemodes.filter(p => p.module === game_mode).pop()

        if (!selectedGameMode) {
            setGameMode(gamemodes.filter(p => p.free && p.default).pop().module)
        }

        if (!game_room && game_mode === 'sa') {
            setGameRoom(saTables[0])
        }

        if (game_room && game_mode === 'manual') {
            setGameRoom(null)
        }
    }

    render() {
        const { subscription, subscription_expire, setGameMode, close, game_mode, loading, saTables, game_room } = this.props;

        const vip = !noPackage(subscription, subscription_expire)

        const Scroller = Platform.OS === 'web' ? ScrollViewWeb : ScrollView;

        return <View style={styles.container}>
            <View style={styles.main}>
                <Text
                    style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 20}}
                >เลือกห้อง</Text>

                <Scroller style={{ flexGrow: 1 }}>
                    <View style={{ flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-around'}}>
                        {/*<SATable 
                            data={null}
                            selected={game_mode === 'manual'}
                            onClick={() => this.SelectRoom(null)}
                        />*/}
                        {(saTables || []).map(t => <ScoreTable
                            vendor='sexy'
                            key={t.name}
                            data={t}
                            vip={vip}
                            disabled={!vip || (t.percent <= 0)}
                            selected={game_room === t.name}
                            onClick={this.SelectRoom}
                        />)}
                    </View>
                </Scroller>

            </View>
            <Button
                title="ปิด"
                disabled={!!loading}
                onPress={close}
            />
        </View>
    }
}

const mapStateToProps = state => {
    return {
        game_room: state.settings.game_room,
        game_mode: state.settings.game_mode,
        saTables: state.sa.tables,
        loading: state.app.loading,
        subscription: state.auth.subscription,
        subscription_expire: state.auth.subscription_expire,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getSexyTables: () => dispatch(getSexyTables()),
        setGameMode: (p) => dispatch(setGameMode(p)),
        setGameRoom: (p) => dispatch(setGameRoom(p)),
    };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(Gamemode);

const styles = StyleSheet.create({
    container: {
        backgroundColor: '#ffffff',
        padding: 10,
        flex: 1,
        // justifyContent: 'space-between',
        maxWidth: '100%',
        margin: 'auto'
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    labelRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 10
    },
    main: {
        flex: 1,
        maxWidth: 700,
    },
    saOff: {
        flexGrow: 1,
        flexDirection: 'row',
        height: 70,
        margin: 5,
        alignItems: 'stretch',
        alignContent: 'center',
        justifyContent: 'center',
        backgroundColor: '#aaaaaa',
        borderRadius: 3,
    },
    saOn: {
        flexGrow: 1, 
        flexDirection: 'row',
        height: 70,
        margin: 5,
        alignItems: 'stretch',
        alignContent: 'center',
        justifyContent: 'center',
        borderRadius: 3,
        backgroundColor: 'khaki',
    }
});
  
  